import { useDispatch, useSelector } from "react-redux";
import { AccountCard } from "../../components";
import { RootState } from "store";
import { userLogoutActionCreator } from "api/UserAPI";
import { Container } from "./styledComponents";
import {useHistory, useLocation} from "react-router";
import { logout } from "reducers/userInfo";
import React from "react";
import Button from "../../../../components/Button";
import styled from "styled-components";
import Icon from "../../../../components/Icon";
import { removeToken } from '../../../../utils';

const MainHeader = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const userName = useSelector((state: RootState) => state.userInfo.name);


  const handleLogout = () => {
    removeToken();
    dispatch(logout());
    dispatch(userLogoutActionCreator());
    history.push("/login");
  };

  return (
    <Container>
      {location.pathname === '/' ? <div/> :
      <Button>
        <LeftIcon
            icon="ArrowLeftIcon"
            size="m"
            color="#545454"
            onClick={() => history.goBack()}
        />
      </Button>
      }
      <AccountCard name={userName} onClickLogout={handleLogout} />
    </Container>
  );
};

const LeftIcon = styled(Icon)``;

export default MainHeader;
